import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export var TextVariants;

(function (TextVariants) {
  TextVariants["h1"] = "h1";
  TextVariants["h2"] = "h2";
  TextVariants["h3"] = "h3";
  TextVariants["h4"] = "h4";
  TextVariants["h5"] = "h5";
  TextVariants["h6"] = "h6";
  TextVariants["p"] = "p";
  TextVariants["a"] = "a";
  TextVariants["small"] = "small";
  TextVariants["blockquote"] = "blockquote";
  TextVariants["pre"] = "pre";
})(TextVariants || (TextVariants = {}));

export var Text = function Text(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? TextVariants.p : _a$component,
      props = __rest(_a, ["children", "className", "component"]);

  var Component = component;
  return React.createElement(Component, Object.assign({}, props, {
    "data-pf-content": true,
    className: css(className)
  }), children);
};